import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ed18b6c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "advisor-page" }
const _hoisted_2 = { class: "advisor-header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "advisor-eyebrow" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "ph ph-sparkle" }),
    /*#__PURE__*/_createTextVNode(" Inteligência para seus planos")
  ]),
  /*#__PURE__*/_createElementVNode("h1", null, "Planejamento com IA"),
  /*#__PURE__*/_createElementVNode("p", null, "Seus números transformados em próximos passos simples.")
], -1))
const _hoisted_4 = { class: "advisor-header__actions" }
const _hoisted_5 = {
  key: 0,
  class: "updated-pill"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ph ph-check-circle" }, null, -1))
const _hoisted_7 = ["disabled"]
const _hoisted_8 = {
  key: 0,
  class: "advisor-feedback",
  role: "alert"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ph ph-warning-circle" }, null, -1))
const _hoisted_10 = {
  key: 1,
  class: "advisor-loading",
  "aria-label": "Carregando planejamento",
  role: "status"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "advisor-skeleton advisor-skeleton--hero" }, null, -1))
const _hoisted_12 = { class: "advisor-skeleton-grid" }
const _hoisted_13 = {
  key: 0,
  class: "goal-picker",
  "aria-label": "Escolher meta analisada"
}
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "goal-picker__label" }
const _hoisted_16 = ["aria-label"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "advisor-hero__glow",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_18 = { class: "advisor-hero__main" }
const _hoisted_19 = { class: "advisor-hero__topline" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ph ph-brain" }, null, -1))
const _hoisted_21 = { class: "confidence-pill" }
const _hoisted_22 = {
  key: 0,
  class: "goal-progress-card"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Meta analisada", -1))
const _hoisted_24 = { class: "goal-progress-card__amount" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Falta guardar", -1))
const _hoisted_26 = { class: "advisor-progress" }
const _hoisted_27 = { class: "goal-progress-card__legend" }
const _hoisted_28 = {
  key: 1,
  class: "no-goal-callout"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "no-goal-callout__icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "ph ph-target" })
], -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Dê um destino para sua economia"),
  /*#__PURE__*/_createElementVNode("small", null, "Cadastre uma meta e receba um plano específico para realizá-la.")
], -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ph ph-arrow-right" }, null, -1))
const _hoisted_32 = { class: "advisor-hero__plan" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "advisor-eyebrow advisor-eyebrow--light" }, "Leitura do mês", -1))
const _hoisted_34 = {
  key: 0,
  class: "plan-numbers"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Para atingir a meta", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "você precisa guardar por mês", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Dinheiro que sobra hoje", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "depois dos gastos do mês", -1))
const _hoisted_39 = { class: "plan-numbers__gap" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Quanto precisa liberar", -1))
const _hoisted_41 = {
  key: 1,
  class: "plan-numbers"
}
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Gasto médio", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "por mês", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Em 12 meses", -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "mantendo o ritmo", -1))
const _hoisted_46 = { key: 0 }
const _hoisted_47 = { key: 1 }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Você não precisa cortar gastos para cumprir esta meta.", -1))
const _hoisted_49 = {
  key: 2,
  class: "advisor-comparison",
  "aria-labelledby": "comparison-title"
}
const _hoisted_50 = { class: "comparison-heading" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "advisor-eyebrow" }, "Veja a diferença", -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { id: "comparison-title" }, "O que acontece se você reduzir alguns gastos?", -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "comparison-heading__icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "ph ph-scales" })
], -1))
const _hoisted_54 = {
  class: "comparison-flow",
  "aria-label": "Comparação dos gastos mensais"
}
const _hoisted_55 = { class: "comparison-state comparison-state--current" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Hoje, sem mudar nada", -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "de gastos por mês", -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "comparison-arrow",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "ph ph-arrow-right" })
], -1))
const _hoisted_59 = { class: "comparison-state comparison-state--reduced" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Com as reduções sugeridas", -1))
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "de gastos por mês", -1))
const _hoisted_62 = { class: "comparison-benefit" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "ph ph-piggy-bank" })
], -1))
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Dinheiro que deixa de sair", -1))
const _hoisted_65 = {
  key: 0,
  class: "goal-date-comparison"
}
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Sem reduzir gastos", -1))
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "previsão atual da meta", -1))
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "ph ph-arrow-right" })
], -1))
const _hoisted_69 = { class: "is-better" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Com a redução sugerida", -1))
const _hoisted_71 = {
  class: "advisor-overview",
  "aria-label": "Resumo financeiro usado na análise"
}
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "ph ph-receipt" })
], -1))
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Você gasta hoje por mês", -1))
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "ph ph-calendar-blank" })
], -1))
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Se nada mudar, em 1 ano", -1))
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "ph ph-wallet" })
], -1))
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Dinheiro que sobra por mês", -1))
const _hoisted_78 = {
  key: 3,
  class: "advisor-panel annual-outlook"
}
const _hoisted_79 = /*#__PURE__*/_createStaticVNode("<header class=\"panel-heading\" data-v-ed18b6c6><div data-v-ed18b6c6><span class=\"advisor-eyebrow\" data-v-ed18b6c6>Sem fazer mudanças</span><h2 data-v-ed18b6c6>Quanto esses gastos custam em 1 ano</h2></div><span class=\"panel-icon panel-icon--blue\" data-v-ed18b6c6><i class=\"ph ph-chart-bar\" data-v-ed18b6c6></i></span></header><p class=\"panel-description\" data-v-ed18b6c6>Estes valores mostram quanto você tende a gastar se continuar no ritmo atual. Não é preciso cortar tudo.</p>", 2)
const _hoisted_81 = { class: "annual-category-grid" }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, " em 12 meses", -1))
const _hoisted_83 = { class: "advisor-columns" }
const _hoisted_84 = { class: "advisor-panel category-opportunities" }
const _hoisted_85 = /*#__PURE__*/_createStaticVNode("<header class=\"panel-heading\" data-v-ed18b6c6><div data-v-ed18b6c6><span class=\"advisor-eyebrow\" data-v-ed18b6c6>Onde existe espaço</span><h2 data-v-ed18b6c6>Oportunidades por categoria</h2></div><span class=\"panel-icon\" data-v-ed18b6c6><i class=\"ph ph-chart-donut\" data-v-ed18b6c6></i></span></header><p class=\"panel-description\" data-v-ed18b6c6>Chamamos de gastos ajustáveis: valores que podem ser revistos sem decisões radicais.</p>", 2)
const _hoisted_87 = {
  key: 0,
  class: "opportunity-list"
}
const _hoisted_88 = { class: "opportunity-rank" }
const _hoisted_89 = { class: "opportunity-content" }
const _hoisted_90 = { class: "opportunity-values" }
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Você gasta hoje", -1))
const _hoisted_92 = { class: "is-reduced" }
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Se fizer a redução", -1))
const _hoisted_94 = { class: "opportunity-saving" }
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ph ph-piggy-bank" }, null, -1))
const _hoisted_96 = {
  key: 1,
  class: "panel-empty"
}
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ph ph-notebook" }, null, -1))
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Ainda faltam dados por categoria", -1))
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Continue registrando seus gastos para receber sugestões mais precisas.", -1))
const _hoisted_100 = [
  _hoisted_97,
  _hoisted_98,
  _hoisted_99
]
const _hoisted_101 = { class: "advisor-panel scenarios-panel" }
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", { class: "panel-heading" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("span", { class: "advisor-eyebrow" }, "Sua meta"),
    /*#__PURE__*/_createElementVNode("h2", null, "Sem redução x com redução")
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "panel-icon panel-icon--blue" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "ph ph-trend-up" })
  ])
], -1))
const _hoisted_103 = {
  key: 0,
  class: "scenario-list"
}
const _hoisted_104 = { class: "scenario-topline" }
const _hoisted_105 = {
  key: 0,
  class: "scenario-date-comparison"
}
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Sem reduzir", -1))
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-arrow-right",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_108 = { class: "is-better" }
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Com a redução", -1))
const _hoisted_110 = { class: "scenario-result" }
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "ph ph-fast-forward" })
], -1))
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Você pode alcançar a meta cerca de", -1))
const _hoisted_113 = {
  key: 1,
  class: "scenario-date"
}
const _hoisted_114 = {
  key: 1,
  class: "panel-empty"
}
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ph ph-path" }, null, -1))
const _hoisted_116 = { class: "advisor-panel action-plan" }
const _hoisted_117 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", { class: "panel-heading" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("span", { class: "advisor-eyebrow" }, "Plano simples"),
    /*#__PURE__*/_createElementVNode("h2", null, "Recomendações personalizadas")
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "panel-icon" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "ph ph-list-checks" })
  ])
], -1))
const _hoisted_118 = { class: "recommendation-grid" }
const _hoisted_119 = { class: "recommendation-number" }
const _hoisted_120 = { key: 0 }
const _hoisted_121 = { class: "advisor-columns advisor-columns--lower" }
const _hoisted_122 = { class: "advisor-panel compact-panel" }
const _hoisted_123 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", { class: "panel-heading" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("span", { class: "advisor-eyebrow" }, "Outra alavanca"),
    /*#__PURE__*/_createElementVNode("h2", null, "Ideias de renda extra")
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "panel-icon panel-icon--orange" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "ph ph-coins" })
  ])
], -1))
const _hoisted_124 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ph ph-plus-circle" }, null, -1))
const _hoisted_125 = {
  key: 0,
  class: "panel-empty panel-empty--small"
}
const _hoisted_126 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Nenhuma sugestão responsável com os dados atuais.", -1))
const _hoisted_127 = [
  _hoisted_126
]
const _hoisted_128 = { class: "advisor-panel compact-panel" }
const _hoisted_129 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", { class: "panel-heading" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("span", { class: "advisor-eyebrow" }, "Comece por aqui"),
    /*#__PURE__*/_createElementVNode("h2", null, "Próximos passos")
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "panel-icon panel-icon--blue" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "ph ph-footprints" })
  ])
], -1))
const _hoisted_130 = { class: "advisor-disclaimer" }
const _hoisted_131 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "ph ph-shield-check" })
], -1))
const _hoisted_132 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Análise privada e orientativa", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FinancialPrivacyButton = _resolveComponent("FinancialPrivacyButton")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_FinancialPrivacyButton),
        (_ctx.advisor?.generated_at)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
              _hoisted_6,
              _createTextVNode(" Atualizado " + _toDisplayString(_ctx.formatShortDate(_ctx.advisor.generated_at)), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          type: "button",
          class: "refresh-advisor",
          disabled: _ctx.loading,
          "aria-label": "Atualizar planejamento",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.loadAdvisor(_ctx.selectedGoalId)))
        }, [
          _createElementVNode("i", {
            class: _normalizeClass(["ph ph-arrow-clockwise", { 'is-spinning': _ctx.loading }])
          }, null, 2)
        ], 8, _hoisted_7)
      ])
    ]),
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("span", null, [
            _hoisted_9,
            _createTextVNode(_toDisplayString(_ctx.error), 1)
          ]),
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.loadAdvisor(_ctx.selectedGoalId)))
          }, "Tentar novamente")
        ]))
      : _createCommentVNode("", true),
    (_ctx.loading && !_ctx.advisor)
      ? (_openBlock(), _createElementBlock("section", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (item) => {
              return _createElementVNode("div", {
                key: item,
                class: "advisor-skeleton"
              })
            }), 64))
          ])
        ]))
      : (_ctx.advisor)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            (_ctx.advisor.goals?.length)
              ? (_openBlock(), _createElementBlock("nav", _hoisted_13, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.advisor.goals, (goal) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: goal.id,
                      type: "button",
                      class: _normalizeClass({ active: Number(_ctx.selectedGoalId) === Number(goal.id) }),
                      onClick: ($event: any) => (_ctx.chooseGoal(goal.id))
                    }, [
                      _createElementVNode("span", _hoisted_15, _toDisplayString(goal.title), 1),
                      _createElementVNode("small", {
                        class: "goal-picker__progress",
                        "aria-label": `${goal.metrics.progress_percentage}% concluído`
                      }, _toDisplayString(goal.metrics.progress_percentage) + "% ", 9, _hoisted_16)
                    ], 10, _hoisted_14))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("section", {
              class: _normalizeClass(["advisor-hero", `advisor-hero--${_ctx.analysis.feasibility}`])
            }, [
              _hoisted_17,
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("span", null, [
                    _hoisted_20,
                    _createTextVNode(_toDisplayString(_ctx.selectedGoal ? 'Plano para sua meta' : 'Diagnóstico financeiro'), 1)
                  ]),
                  _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.analysis.confidence_percent) + "% de confiança", 1)
                ]),
                _createElementVNode("h2", null, _toDisplayString(_ctx.analysis.headline), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.privateText(_ctx.analysis.summary)), 1),
                (_ctx.selectedGoal)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                      _createElementVNode("div", null, [
                        _createElementVNode("span", null, [
                          _hoisted_23,
                          _createElementVNode("strong", null, _toDisplayString(_ctx.selectedGoal.title), 1)
                        ]),
                        _createElementVNode("span", _hoisted_24, [
                          _hoisted_25,
                          _createElementVNode("strong", null, _toDisplayString(_ctx.privateValue(_ctx.selectedGoal.metrics.remaining_amount.formatted)), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("span", {
                          style: _normalizeStyle({ width: `${_ctx.selectedGoal.metrics.progress_percentage}%` })
                        }, null, 4)
                      ]),
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("b", null, _toDisplayString(_ctx.selectedGoal.metrics.progress_percentage) + "% concluída", 1),
                        _createElementVNode("span", null, "até " + _toDisplayString(_ctx.formatDate(_ctx.selectedGoal.target_date)), 1)
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_28, [
                      _hoisted_29,
                      _hoisted_30,
                      _createVNode(_component_router_link, { to: "/financial-goals" }, {
                        default: _withCtx(() => [
                          _createTextVNode("Criar meta "),
                          _hoisted_31
                        ]),
                        _: 1
                      })
                    ]))
              ]),
              _createElementVNode("aside", _hoisted_32, [
                _hoisted_33,
                _createElementVNode("h3", null, _toDisplayString(_ctx.feasibilityLabel), 1),
                (_ctx.selectedGoal)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                      _createElementVNode("article", null, [
                        _hoisted_35,
                        _createElementVNode("strong", null, _toDisplayString(_ctx.privateValue(_ctx.analysis.monthly_gap.goal_required.formatted)), 1),
                        _hoisted_36
                      ]),
                      _createElementVNode("article", null, [
                        _hoisted_37,
                        _createElementVNode("strong", {
                          class: _normalizeClass({ negative: _ctx.analysis.monthly_gap.current_surplus.raw < 0 })
                        }, _toDisplayString(_ctx.privateValue(_ctx.analysis.monthly_gap.current_surplus.formatted)), 3),
                        _hoisted_38
                      ]),
                      _createElementVNode("article", _hoisted_39, [
                        _hoisted_40,
                        _createElementVNode("strong", null, _toDisplayString(_ctx.privateValue(_ctx.analysis.monthly_gap.gap.formatted)), 1),
                        _createElementVNode("span", null, _toDisplayString(_ctx.analysis.monthly_gap.gap.raw > 0 ? 'por mês para a meta caber' : 'nenhum corte é obrigatório para esta meta'), 1)
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_41, [
                      _createElementVNode("article", null, [
                        _hoisted_42,
                        _createElementVNode("strong", null, _toDisplayString(_ctx.privateValue(_ctx.advisor.spending.cash_flow.monthly_expense_average.formatted)), 1),
                        _hoisted_43
                      ]),
                      _createElementVNode("article", null, [
                        _hoisted_44,
                        _createElementVNode("strong", null, _toDisplayString(_ctx.privateValue(_ctx.advisor.spending.cash_flow.projected_expense_12_months.formatted)), 1),
                        _hoisted_45
                      ])
                    ])),
                (_ctx.selectedGoal)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 2,
                      class: _normalizeClass(["plan-guidance", { 'needs-adjustment': _ctx.analysis.monthly_gap.gap.raw > 0 }])
                    }, [
                      _createElementVNode("i", {
                        class: _normalizeClass(_ctx.analysis.monthly_gap.gap.raw > 0 ? 'ph ph-warning-circle' : 'ph ph-check-circle'),
                        "aria-hidden": "true"
                      }, null, 2),
                      (_ctx.analysis.monthly_gap.gap.raw > 0)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_46, [
                            _createElementVNode("strong", null, "Você precisa reduzir ou ganhar mais " + _toDisplayString(_ctx.privateValue(_ctx.analysis.monthly_gap.gap.formatted)) + " por mês.", 1),
                            _createTextVNode(" Esse é o valor que falta para conseguir guardar o necessário para a meta. ")
                          ]))
                        : (_openBlock(), _createElementBlock("p", _hoisted_47, [
                            _hoisted_48,
                            _createTextVNode(" Se reduzir alguns gastos, poderá chegar antes ou guardar uma reserva maior. ")
                          ]))
                    ], 2))
                  : _createCommentVNode("", true)
              ])
            ], 2),
            (_ctx.advisor.is_stale)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass(["analysis-status", { failed: _ctx.advisor.status === 'failed' }])
                }, [
                  _createElementVNode("span", null, [
                    _createElementVNode("i", {
                      class: _normalizeClass(_ctx.advisor.status === 'failed' ? 'ph ph-warning-circle' : 'ph ph-hourglass-medium')
                    }, null, 2)
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("strong", null, _toDisplayString(_ctx.advisor.status === 'failed' ? 'A última atualização não foi concluída' : 'Sua análise personalizada está sendo preparada'), 1),
                    _createElementVNode("small", null, _toDisplayString(_ctx.advisor.status === 'failed' ? 'As orientações anteriores ou estimativas iniciais continuam disponíveis.' : 'Ela considera alterações feitas nos primeiros 5 minutos da meta e aparecerá automaticamente aqui.'), 1)
                  ])
                ], 2))
              : _createCommentVNode("", true),
            (_ctx.advisor.spending.categories?.length)
              ? (_openBlock(), _createElementBlock("section", _hoisted_49, [
                  _createElementVNode("header", _hoisted_50, [
                    _createElementVNode("div", null, [
                      _hoisted_51,
                      _hoisted_52,
                      _createElementVNode("p", null, _toDisplayString(_ctx.comparisonSummary), 1)
                    ]),
                    _hoisted_53
                  ]),
                  _createElementVNode("div", _hoisted_54, [
                    _createElementVNode("article", _hoisted_55, [
                      _hoisted_56,
                      _createElementVNode("strong", null, _toDisplayString(_ctx.privateValue(_ctx.advisor.spending.cash_flow.monthly_expense_average.formatted)), 1),
                      _hoisted_57
                    ]),
                    _hoisted_58,
                    _createElementVNode("article", _hoisted_59, [
                      _hoisted_60,
                      _createElementVNode("strong", null, _toDisplayString(_ctx.privateValue(_ctx.formatMoney(_ctx.monthlyExpenseAfterReduction))), 1),
                      _hoisted_61
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_62, [
                    _hoisted_63,
                    _createElementVNode("div", null, [
                      _hoisted_64,
                      _createElementVNode("strong", null, _toDisplayString(_ctx.privateValue(_ctx.formatMoney(_ctx.monthlyReductionTotal))) + " por mês", 1),
                      _createElementVNode("p", null, [
                        _createTextVNode("Isso pode virar "),
                        _createElementVNode("b", null, _toDisplayString(_ctx.privateValue(_ctx.formatMoney(_ctx.annualSavingsTotal))), 1),
                        _createTextVNode(" guardados em 1 ano.")
                      ])
                    ])
                  ]),
                  (_ctx.selectedGoal && _ctx.primaryScenario)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                        _createElementVNode("article", null, [
                          _hoisted_66,
                          _createElementVNode("strong", null, _toDisplayString(_ctx.formatDate(_ctx.selectedGoal.target_date)), 1),
                          _hoisted_67
                        ]),
                        _hoisted_68,
                        _createElementVNode("article", _hoisted_69, [
                          _hoisted_70,
                          _createElementVNode("strong", null, _toDisplayString(_ctx.primaryScenario.estimated_new_date ? _ctx.formatDate(_ctx.primaryScenario.estimated_new_date) : 'Prazo menor'), 1),
                          _createElementVNode("span", null, _toDisplayString(_ctx.monthsSavedLabel(_ctx.primaryScenario.estimated_months_saved)) + " antes", 1)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("section", _hoisted_71, [
              _createElementVNode("article", null, [
                _hoisted_72,
                _createElementVNode("div", null, [
                  _hoisted_73,
                  _createElementVNode("strong", null, _toDisplayString(_ctx.privateValue(_ctx.advisor.spending.cash_flow.monthly_expense_average.formatted)), 1)
                ])
              ]),
              _createElementVNode("article", null, [
                _hoisted_74,
                _createElementVNode("div", null, [
                  _hoisted_75,
                  _createElementVNode("strong", null, _toDisplayString(_ctx.privateValue(_ctx.advisor.spending.cash_flow.projected_expense_12_months.formatted)), 1)
                ])
              ]),
              _createElementVNode("article", null, [
                _hoisted_76,
                _createElementVNode("div", null, [
                  _hoisted_77,
                  _createElementVNode("strong", {
                    class: _normalizeClass({ negative: _ctx.advisor.spending.cash_flow.monthly_balance_estimate.raw < 0 })
                  }, _toDisplayString(_ctx.privateValue(_ctx.advisor.spending.cash_flow.monthly_balance_estimate.formatted)), 3)
                ])
              ])
            ]),
            (_ctx.advisor.spending.categories?.length)
              ? (_openBlock(), _createElementBlock("section", _hoisted_78, [
                  _hoisted_79,
                  _createElementVNode("div", _hoisted_81, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.advisor.spending.categories, (item) => {
                      return (_openBlock(), _createElementBlock("article", {
                        key: `${item.category_id}-${item.category}`
                      }, [
                        _createElementVNode("span", null, [
                          _createElementVNode("strong", null, _toDisplayString(item.category), 1),
                          _createElementVNode("small", null, _toDisplayString(_ctx.privateValue(`${item.monthly_average.formatted}/mês`)), 1)
                        ]),
                        _createElementVNode("b", null, [
                          _createTextVNode(_toDisplayString(_ctx.privateValue(item.projected_12_months.formatted)), 1),
                          _hoisted_82
                        ])
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_83, [
              _createElementVNode("section", _hoisted_84, [
                _hoisted_85,
                (_ctx.analysis.category_opportunities.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_87, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.analysis.category_opportunities, (item, index) => {
                        return (_openBlock(), _createElementBlock("article", {
                          key: item.category
                        }, [
                          _createElementVNode("div", _hoisted_88, _toDisplayString(index + 1), 1),
                          _createElementVNode("div", _hoisted_89, [
                            _createElementVNode("header", null, [
                              _createElementVNode("strong", null, _toDisplayString(item.category), 1),
                              _createElementVNode("span", null, "economizar " + _toDisplayString(_ctx.privateValue(`${item.suggested_reduction.formatted}/mês`)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_90, [
                              _createElementVNode("span", null, [
                                _hoisted_91,
                                _createElementVNode("b", null, _toDisplayString(_ctx.privateValue(`${item.monthly_average.formatted}/mês`)), 1)
                              ]),
                              _createElementVNode("span", _hoisted_92, [
                                _hoisted_93,
                                _createElementVNode("b", null, _toDisplayString(_ctx.privateValue(`${_ctx.formatMoney(_ctx.categoryAfterReduction(item))}/mês`)), 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_94, [
                              _hoisted_95,
                              _createElementVNode("span", null, [
                                _createTextVNode("Você pode guardar "),
                                _createElementVNode("b", null, _toDisplayString(_ctx.privateValue(_ctx.formatMoney(_ctx.annualReduction(item)))), 1),
                                _createTextVNode(" em 1 ano")
                              ])
                            ]),
                            _createElementVNode("p", null, _toDisplayString(_ctx.privateText(item.reason)), 1)
                          ])
                        ]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_96, _hoisted_100))
              ]),
              _createElementVNode("section", _hoisted_101, [
                _hoisted_102,
                (_ctx.analysis.scenarios.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_103, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.analysis.scenarios, (scenario) => {
                        return (_openBlock(), _createElementBlock("article", {
                          key: scenario.title
                        }, [
                          _createElementVNode("div", _hoisted_104, [
                            _createElementVNode("span", null, _toDisplayString(scenario.confidence_percent) + "% de confiança", 1),
                            _createElementVNode("strong", null, _toDisplayString(_ctx.privateValue(`+ ${scenario.monthly_improvement.formatted}/mês`)), 1)
                          ]),
                          _createElementVNode("h3", null, _toDisplayString(scenario.title), 1),
                          (_ctx.selectedGoal)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_105, [
                                _createElementVNode("span", null, [
                                  _hoisted_106,
                                  _createElementVNode("b", null, _toDisplayString(_ctx.formatDate(_ctx.selectedGoal.target_date)), 1)
                                ]),
                                _hoisted_107,
                                _createElementVNode("span", _hoisted_108, [
                                  _hoisted_109,
                                  _createElementVNode("b", null, _toDisplayString(scenario.estimated_new_date ? _ctx.formatDate(scenario.estimated_new_date) : 'Prazo menor'), 1)
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_110, [
                            _hoisted_111,
                            _createElementVNode("div", null, [
                              _hoisted_112,
                              _createElementVNode("strong", null, _toDisplayString(_ctx.monthsSavedLabel(scenario.estimated_months_saved)) + " antes", 1)
                            ])
                          ]),
                          _createElementVNode("p", null, _toDisplayString(_ctx.privateText(scenario.explanation)), 1),
                          (scenario.estimated_new_date)
                            ? (_openBlock(), _createElementBlock("small", _hoisted_113, "Nova previsão: " + _toDisplayString(_ctx.formatDate(scenario.estimated_new_date)), 1))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_114, [
                      _hoisted_115,
                      _createElementVNode("strong", null, _toDisplayString(_ctx.selectedGoal ? 'Cenários em preparação' : 'Cadastre uma meta para simular prazos'), 1),
                      _createElementVNode("span", null, _toDisplayString(_ctx.selectedGoal ? 'A IA cruzará economia possível, valor restante e prazo.' : 'Com uma meta, mostramos quanto cada ajuste pode antecipar sua conquista.'), 1)
                    ]))
              ])
            ]),
            _createElementVNode("section", _hoisted_116, [
              _hoisted_117,
              _createElementVNode("div", _hoisted_118, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.analysis.recommendations, (item, index) => {
                  return (_openBlock(), _createElementBlock("article", {
                    key: `${item.title}-${index}`
                  }, [
                    _createElementVNode("div", _hoisted_119, _toDisplayString(String(index + 1).padStart(2, '0')), 1),
                    _createElementVNode("span", {
                      class: _normalizeClass(["priority-pill", `priority-pill--${item.priority}`])
                    }, _toDisplayString(_ctx.priorityLabel(item.priority)), 3),
                    _createElementVNode("h3", null, _toDisplayString(item.title), 1),
                    _createElementVNode("p", null, _toDisplayString(_ctx.privateText(item.description)), 1),
                    (item.monthly_impact.raw > 0)
                      ? (_openBlock(), _createElementBlock("strong", _hoisted_120, "Impacto estimado: " + _toDisplayString(_ctx.privateValue(`${item.monthly_impact.formatted}/mês`)), 1))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_121, [
              _createElementVNode("section", _hoisted_122, [
                _hoisted_123,
                _createElementVNode("ul", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.analysis.income_ideas, (idea) => {
                    return (_openBlock(), _createElementBlock("li", { key: idea }, [
                      _hoisted_124,
                      _createElementVNode("span", null, _toDisplayString(idea), 1)
                    ]))
                  }), 128))
                ]),
                (!_ctx.analysis.income_ideas.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_125, _hoisted_127))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("section", _hoisted_128, [
                _hoisted_129,
                _createElementVNode("ol", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.analysis.next_steps, (step, index) => {
                    return (_openBlock(), _createElementBlock("li", { key: step }, [
                      _createElementVNode("b", null, _toDisplayString(index + 1), 1),
                      _createElementVNode("span", null, _toDisplayString(step), 1)
                    ]))
                  }), 128))
                ])
              ])
            ]),
            _createElementVNode("footer", _hoisted_130, [
              _hoisted_131,
              _createElementVNode("div", null, [
                _hoisted_132,
                _createElementVNode("p", null, _toDisplayString(_ctx.analysis.disclaimer) + " " + _toDisplayString(_ctx.advisor.privacy.message), 1)
              ])
            ])
          ], 64))
        : _createCommentVNode("", true)
  ]))
}